import {
	Chip,
	Box,
	Typography,
	TextField,
	Autocomplete,
	Select,
	MenuItem,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Avatar,
	Divider,
	Stack,
	FormControl,
	InputLabel,
	Paper,
	CircularProgress,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	SvgIcon,
	Popover,
	RadioGroup,
	Radio,
	FormControlLabel,
	FormLabel,
	IconButton,
	Grid,
	Alert,
} from "@mui/material";
import { MoteIcon } from "constants/mote";

import { LaunchRounded, RssFeed } from "@mui/icons-material";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { SearchOutlined, Article } from "@mui/icons-material";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import FolderIcon from "@mui/icons-material/Folder";

import React, {
	useState,
	useEffect,
	Fragment,
	useMemo,
	useCallback,
} from "react";

import { useSelector } from "react-redux";
import { set, subDays, subMonths } from "date-fns";
import format from "date-fns/format";

// import ReactFlow, { MiniMap, Controls } from "react-flow-renderer";
import Tree from "react-d3-tree";
import "./custom-tree.css";
import html2canvas from "html2canvas";

import { saveAs } from "file-saver";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import throttle from "lodash/throttle";
import FlexBetweenBox from "components/FlexBetweenBox";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const FileDialogComponent = ({
	selectedNode,
	summaryData,
	setSummaryData,
	token,
	openDialog,
	setOpenDialog,
}) => {
	const [isGettingSummary, setIsGettingSummary] = useState(false);
	const [aggregatedSummary, setAggregatedSummary] = useState(null);
	useEffect(() => {
		// Effect function to run when `text` variable changes
		console.log("Text updated:", summaryData);
	}, [summaryData, isGettingSummary]); // Pass `text` as a dependency array to `useEffect`

	const handleAggregatedSummaryClick = async () => {
		setIsGettingSummary(true);
		//run bfs on children
		let currNode = selectedNode;
		const noteBatch = [];
		let frontier = [currNode];
		while (frontier.length) {
			// console.log("frontier is", frontier);
			let temp = [];
			while (frontier.length) {
				temp.push(frontier.pop());
			}

			while (temp.length) {
				currNode = temp.pop();
				console.log("At node", currNode);
				if (currNode.children) {
					//still at a folder, at to frontier
					frontier = frontier.concat(currNode.children);
					continue;
				} else {
					//leaf node has an issue of not containing a note obj
					if (!currNode.attributes) {
						console.log("leaf node at ", currNode, " doesn't have attributes");
						continue;
					}
					//making the out obj for backend
					let noteObj = currNode.attributes;

					noteBatch.push(noteObj);
				}
			}
		}
		console.log("selected Node is ", selectedNode);
		const url = `${process.env.REACT_APP_PORT}/summarizer/getOpenAIResponse`;
		const body = {
			notes: noteBatch,
		};

		const response = await fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(body),
		});
		const res = await response.json();

		const individualOpenAIResponses = res.data;
		const individualSummaries = [];
		for (let i = 0; i < individualOpenAIResponses.length; i++) {
			individualSummaries.push(individualOpenAIResponses[i].summary);
		}

		const newUrl =
			`${process.env.REACT_APP_PORT}/summarizer/getAggregatedSummary`;
		const newBody = {
			individualSummaries: individualSummaries,
		};

		const newResponse = await fetch(newUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(newBody),
		});
		const newRes = await newResponse.json();

		setIsGettingSummary(false);
		setAggregatedSummary(newRes.parsedAggregatedSummary);
	};

	const handleSummaryClick = async () => {
		setIsGettingSummary(true);
		const url = `${process.env.REACT_APP_PORT}/summarizer/getOpenAIResponse`;
		//selected Node.attributes should be the note obj
		const noteObj = selectedNode.attributes;

		const body = {
			notes: [noteObj],
		};

		const response = await fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(body),
		});
		const res = await response.json();

		setIsGettingSummary(false);
		setSummaryData(res.data[0]);
	};

	return (
		//
		<>
			{selectedNode &&
				(selectedNode.children ? (
					// OPENING FOLDER DIALOG
					<Dialog
						open={openDialog}
						onClose={() => setOpenDialog(false)}
						fullWidth={true}
					>
						<DialogTitle>
							<Typography variant="h4" align="center" fontWeight="bold">
								Folder Name: {selectedNode.name}
							</Typography>
						</DialogTitle>
						<DialogContent>
							{/* SUBFILE SUMMARIES */}
							<Box sx={{ paddingBottom: "18px" }}>
								<Typography
									variant="body"
									paddingRight="10px"
									fontWeight="bold"
								>
									Summarized Subfiles:
								</Typography>
							</Box>
							{/* GETTING AGGREGATED SUMMARY */}
							<Box sx={{ paddingBottom: "18px" }}>
								<Box sx={{ paddingBottom: "18px" }}>
									<Typography
										variant="body"
										paddingRight="10px"
										fontWeight="bold"
									>
										Aggregate Summary:
									</Typography>
								</Box>
								<Box>
									{aggregatedSummary === null && !isGettingSummary ? (
										<Box
											sx={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											<Button
												variant="contained"
												onClick={handleAggregatedSummaryClick}
												sx={{ borderRadius: 3 }}
											>
												<Typography
													variant="body"
													sx={{ textTransform: "none" }}
												>
													Get Aggregated Summary
												</Typography>
											</Button>
										</Box>
									) : (
										<>
											{isGettingSummary ? (
												<Box
													display="flex"
													justifyContent="center"
													alignItems="center"
												>
													<CircularProgress />
												</Box>
											) : (
												<Typography
													variant="body"
													style={{ whiteSpace: "pre-line" }}
												>
													{aggregatedSummary}
												</Typography>
											)}
										</>
									)}
								</Box>
							</Box>
						</DialogContent>
					</Dialog>
				) : (
					<>
						{selectedNode.attributes && (
							// OPENING File DIALOG
							<Dialog
								open={openDialog}
								onClose={() => setOpenDialog(false)}
								fullWidth={true}
							>
								<DialogTitle>
									<Typography variant="h4" align="center">
										File Name: {selectedNode.name}
									</Typography>
								</DialogTitle>
								<DialogContent>
									{/* KEYWORDS */}
									<Box sx={{ paddingBottom: "18px" }}>
										<Typography variant="body" paddingRight="10px">
											Keywords:
										</Typography>
										{selectedNode.attributes.keywords?.map((keyword) => (
											<Button
												// startIcon={<CloseIcon sx={{ width:10, height:10 }} />}
												variant="outlined"
												sx={{
													margin: "3px",
													fontSize: 10,
													textTransform: "none",
													borderRadius: 5,
												}}
											>
												<Typography
													variant="tableBody"
													sx={{ fontSize: 10, textTransform: "none" }}
												>
													{keyword}
												</Typography>
											</Button>
										))}
									</Box>

									{/* OWNERS */}
									<Box sx={{ paddingBottom: "18px" }}>
										<Typography variant="body" paddingRight="10px">
											Owners:
										</Typography>
										{selectedNode.attributes.owners?.map((owner) => (
											<Button
												startIcon={
													<AccountCircleIcon sx={{ width: 20, height: 20 }} />
												}
												variant="outlined"
												sx={{
													margin: "3px",
													fontSize: 10,
													textTransform: "none",
													borderRadius: 5,
												}}
											>
												<Typography
													variant="tableBody"
													sx={{ fontSize: 10, textTransform: "none" }}
												>
													{owner.emailAddress}
												</Typography>
											</Button>
										))}
									</Box>

									{/* SUMMARY */}
									<Box sx={{ paddingBottom: "18px" }}>
										<Box>
											<Typography variant="body" paddingRight="10px">
												Summary:{" "}
												{selectedNode.attributes.summaryModifiedTime === null &&
												summaryData.summary === "" ? (
													<Alert severity="info">
														This file has not been summarized
													</Alert>
												) : (
													<Alert severity="info">
														Last summarized on{" "}
														{new Date(
															summaryData.summaryModifiedTime
														).toLocaleDateString("en-US", {
															month: "2-digit",
															day: "2-digit",
															year: "numeric",
														})}
													</Alert>
												)}
											</Typography>
										</Box>

										<Box>
											{selectedNode.attributes.summaryModifiedTime === null &&
											summaryData.summary === "" &&
											!isGettingSummary ? (
												<Box
													sx={{
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
													}}
												>
													<Button
														variant="contained"
														onClick={handleSummaryClick}
														sx={{ borderRadius: 3 }}
													>
														<Typography
															variant="body"
															sx={{ textTransform: "none" }}
														>
															Summarize Now
														</Typography>
													</Button>
												</Box>
											) : (
												(console.log("isGettingSummary: ", isGettingSummary),
												(
													<>
														{isGettingSummary && (
															<Box
																display="flex"
																justifyContent="center"
																alignItems="center"
															>
																<CircularProgress />
															</Box>
														)}
														{!isGettingSummary && (
															<Typography
																variant="body"
																style={{ whiteSpace: "pre-line" }}
															>
																{summaryData.summary}
															</Typography>
														)}
													</>
												))
											)}
										</Box>
									</Box>
								</DialogContent>
							</Dialog>
						)}
					</>
				))}
		</>
	);
};

const TimePeriodPickerComponent = ({
	setStartDate,
	setEndDate,
	setTimePeriod,
	allTimePast,
	today,
	timePeriod,
	startDate,
	endDate,
}) => {
	const handleTimePeriodChange = (event) => {
		// clear dates
		setStartDate(null);
		setEndDate(null);

		// set TimePeriod
		setTimePeriod(event.target.value);

		if (event.target.value === "all-time") {
			setStartDate(allTimePast);
			setEndDate(today);
		} else if (
			event.target.value !== "date" &&
			event.target.value !== "date-range"
		) {
			const [sub, unit] = event.target.value.split(" ");
			// set startDate and endDate based on event.target.value chosen
			switch (unit) {
				case "day":
					setStartDate(subDays(today, sub));
					break;
				case "month":
					setStartDate(subMonths(today, sub));
					break;
				default:
					break;
			}

			setEndDate(today);
		}
	};

	const handleOnDateChange = (date) => {
		setStartDate(date);
		setEndDate(date);
	};

	const handleStartDateChange = (date) => {
		setStartDate(date);
	};

	const handleEndDateChange = (date) => {
		setEndDate(date);
	};

	return (
		<Box display="flex" alignItems="center" gap="1rem">
			<FormControl sx={{ mr: 1, minWidth: 170 }} size="small">
				<InputLabel>Time Period</InputLabel>
				<Select
					value={timePeriod}
					label="Time Period"
					onChange={handleTimePeriodChange}
				>
					<MenuItem value="all-time">All Time</MenuItem>
					<MenuItem value="7 day">Last 7 days</MenuItem>
					<MenuItem value="1 month">Last month</MenuItem>
					<MenuItem value="3 month">Last 3 months</MenuItem>
					<MenuItem value="6 month">Last 6 months</MenuItem>
					<MenuItem value="12 month">Last 12 months</MenuItem>
					<Divider />
					<MenuItem value="date">Specific Date</MenuItem>
					<MenuItem value="date-range">Date Range</MenuItem>
				</Select>
			</FormControl>

			{timePeriod === "date" && (
				<Fragment>
					<Typography variant="h5" fontWeight="600" gutterBottom>
						On:
					</Typography>
					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<DatePicker
							disableFuture
							value={startDate} // should be same as endDate
							onChange={handleOnDateChange}
							slotProps={{
								textField: {
									size: "small",
									sx: { width: 180 },
								},
							}}
						/>
					</LocalizationProvider>
				</Fragment>
			)}

			{timePeriod === "date-range" && (
				<Box
					display="flex"
					justifyContent="center"
					alignItems="center"
					gap="1rem"
				>
					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<DatePicker
							disableFuture
							label="Start"
							value={startDate}
							maxDate={endDate}
							onChange={handleStartDateChange}
							slotProps={{
								textField: {
									size: "small",
									sx: { width: 180 },
								},
							}}
						/>
					</LocalizationProvider>

					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<DatePicker
							disableFuture
							label="End"
							value={endDate}
							minDate={startDate}
							onChange={handleEndDateChange}
							slotProps={{
								textField: {
									size: "small",
									sx: { width: 180 },
								},
							}}
						/>
					</LocalizationProvider>
				</Box>
			)}
		</Box>
	);
};

const SearchPage = () => {
	const token = useSelector((state) => state.auth.token);
	const today = useMemo(() => new Date(), []);
	const allTimePast = useMemo(() => new Date(1900, 0, 1), []);

	const [startDate, setStartDate] = useState(allTimePast);
	const [endDate, setEndDate] = useState(today);
	const [timePeriod, setTimePeriod] = useState("all-time");
	const currentWorkspaces = useSelector(
		(state) => state.auth.user?.currentWorkspaces
	);

	const [isError, setIsError] = useState(false);
	const [graphData, setGraphData] = useState(null);
	const [values, setValues] = useState([]);
	const [openDialog, setOpenDialog] = useState(false);
	const [openError, setOpenError] = useState(false);

	const handleCloseError = () => {
		setOpenError(false);
	};

	// throttling requests with help from
	// https://dmitripavlutin.com/react-throttle-debounce/
	const [options, setOptions] = useState([]);
	const [isTyping, setIsTyping] = useState(false); // exclusively for the loading circular progress wheel

	const handleAutocompleteChange = async (event, value) => {
		let query = event.target.value;
		if (!query) {
			query = "";
		}
		if (query.length > 0) {
			query = query.trim();
		}
		setIsTyping(query.length > 0); // exclusively for the loading circular progress wheel

		if (query !== "") {
			// clear old options
			setOptions([]);

			// fetch new options
			let url = new URL(`${process.env.REACT_APP_PORT}/filter/getFilters`);
			url.searchParams.set("query", query);
			const response = await fetch(url, {
				method: "GET",
				headers: { Authorization: `Bearer ${token}` },
			});

			const data = await response.json();

			if (response.status === 200) {
				setOptions(data.filters);
			} else {
				console.log("error");
			}
		}
	};

	const throttledHandleAutocompleteChange = useMemo(
		() => throttle(handleAutocompleteChange, 1000),
		[]
	);

	// Stop the invocation of the throttled function after unmounting
	useEffect(() => {
		return () => {
			throttledHandleAutocompleteChange.cancel();
		};
	}, []);

	const getEdgeGraphData = async (body) => {
		const url = `${process.env.REACT_APP_PORT}/filter/getEdgeGraph`;

		const response = await fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(body),
		});
		const data = await response.json();

		if (response.status === 200) return data;
	};

	//route for setting out request for edge graph
	const handleValueChange = async (event, value) => {
		setValues(value);
		// setSummaryData(null);
		setGraphData(null);
		setIsError(false);

		if (value.length === 0) return;

		const body = {
			startDate: startDate,
			endDate: endDate,
			filterIds: value?.map((filter) => filter._id),
			workspaces: currentWorkspaces,
		};

		const edgeMap = await getEdgeGraphData(body);
		console.log("edgemap is ", edgeMap);

		if (Object.keys(edgeMap).length === 0) {
			setIsError(true);
		}
		setGraphData(edgeMap.edgeMap);
	};

	// const ErrorDialog = () => {
	// 	return (
	// 		<Dialog open={openError} onClose={handleCloseError}>
	// 			<DialogTitle>
	// 				<Box
	// 					display="flex"
	// 					justifyContent="space-between"
	// 					alignItems="center"
	// 				>
	// 					<Box>
	// 						<Typography variant="h4" fontWeight="bold">
	// 							Cannot download document summary
	// 						</Typography>
	// 					</Box>
	// 				</Box>
	// 			</DialogTitle>

	// 			<DialogContent dividers>
	// 				<Typography variant="body1" color="error">
	// 					There is no summary to be downloaded for this document set. Please
	// 					choose a document set that yields a summary.
	// 				</Typography>
	// 			</DialogContent>
	// 		</Dialog>
	// 	);
	// };

	// const downloadSummary = (event) => {
	// 	event.preventDefault();

	// 	console.log(`Downloading to ${fileType}...`, summaryData);
	// 	if (
	// 		summaryData &&
	// 		summaryData.aggregatedSummary &&
	// 		summaryData.individualSummaries
	// 	) {
	// 		let summary = summaryData.aggregatedSummary;
	// 		let title = "Summary of ";

	// 		const keys = Object.entries(
	// 			Object.entries(summaryData.individualSummaries)
	// 		);
	// 		for (const [index, [key, value]] of keys) {
	// 			if (index < Object.keys(summaryData.individualSummaries).length - 1)
	// 				title += `${value.name}, `;
	// 			else title += `and ${value.name}`;
	// 		}

	// 		if (fileType === "pdf") {
	// 			const docDefinition = {
	// 				header: {
	// 					columns: [
	// 						{
	// 							text: title,
	// 							bold: true,
	// 							alignment: "center",
	// 						},
	// 					],
	// 				},
	// 				content: [{ text: summary }],
	// 			};

	// 			pdfMake.createPdf(docDefinition).download(`${title}.pdf`);
	// 		} else if (fileType === "doc") {
	// 			const content =
	// 				"{\\rtf1\\ansi\\ansicpg1252\\deff0\\deflang1033{\\fonttbl{\\f0\\fswiss\\fprq2\\fcharset0 Times New Roman;}}\r\n\\viewkind4\\uc1\\pard\\b " +
	// 				title +
	// 				"\\line\\par\r\n" +
	// 				summary +
	// 				"\\par\r\n}";
	// 			const docBlob = new Blob([content], { type: "application/msword" });
	// 			saveAs(docBlob, title + ".doc");
	// 		} else if (fileType === "txt") {
	// 			const txtBlob = new Blob([summary], { type: "text/plain" });
	// 			saveAs(txtBlob, title + ".txt");
	// 		}
	// 	} else setOpenError(true);
	// };

	// set the current node we're at with its data

	const useCenteredTree = (defaultTranslate = { x: 0, y: 0 }) => {
		const [translate, setTranslate] = useState(defaultTranslate);
		const [dimensions, setDimensions] = useState();
		const containerRef = useCallback((containerElem) => {
			if (containerElem !== null) {
				const { width, height } = containerElem.getBoundingClientRect();
				setDimensions({ width, height });
				setTranslate({ x: width / 2, y: height / 2 });
			}
		}, []);
		return [dimensions, translate, containerRef];
	};

	const containerStyles = {
		height: "47vh",
		width: "100%",
	};
	const [dimensions, translate, containerRef] = useCenteredTree();
	const nodeSize = { x: 200, y: 200 };

	const foreignObjectProps = { width: nodeSize.x, height: nodeSize.y, x: 20 };

	// file dialog box

	const [selectedNode, setSelectedNode] = useState(null);
	const [summaryData, setSummaryData] = useState(selectedNode?.attributes);

	// handling click on graph box
	const handleClick = (nodeDatum) => {
		setSelectedNode(nodeDatum);
		setSummaryData(nodeDatum.attributes);
		setOpenDialog(true);

		// const nodeID = nodeDatum.__rd3t.id;
		// const depth = nodeDatum.__rd3t.depth;
	};

	const renderForeignObjectNode = ({
		nodeDatum,
		toggleNode,
		foreignObjectProps,
	}) => {
		// if noteDatum.__rd3t.depth === 0, then it is the root node
		// if !noteDatum.children, then it is a leaf node
		// else it is an intermediate node
		//root color: "#1f3e9e"
		//leaf color: "#f1f0fa"
		//intermediate color: "#b7c4ff"

		let nodeType;
		let color = "#b7c4ff";
		let textColor = "#000000";
		if (nodeDatum.__rd3t.depth === 0) {
			color = "#1f3e9e";
			textColor = "#ffffff";
			nodeType = "root";
		} else if (!nodeDatum.children) {
			color = "#f1f0fa";
			nodeType = "leaf";
		} else if (nodeDatum.__rd3t.depth === 1) {
			nodeType = "drive";
		} else {
			nodeType = "folder";
		}

		return (
			<>
				{/* <foreignObject {...foreignObjectProps}>
					{nodeType === "root" && (
						<img src="assets/images/tim.jpeg" height="100" width="100"/>
					)}
				</foreignObject> */}
				{nodeType === "root" && (
					// <SvgIcon fontSize="12px" >
					<circle fill={color} r={15} onClick={toggleNode} />
					// {/* <FolderIcon onClick={toggleNode} color="primary"  /> */}

					// {/* </SvgIcon> */}
				)}

				{nodeType !== "root" && (
					<circle fill={color} r={15} onClick={toggleNode}></circle>
				)}

				<g>
					{/* `foreignObject` requires width & height to be explicitly set. */}
					<foreignObject {...foreignObjectProps}>
						<div
							style={{
								border: "1px solid black",
								borderRadius: "10px",
								backgroundColor: color,
							}}
							onClick={() => handleClick(nodeDatum)}
						>
							<h3 style={{ textAlign: "center", color: textColor }}>
								{nodeDatum.name}
							</h3>
						</div>
					</foreignObject>
				</g>
			</>
		);
	};

	return (
		<Box p="2rem">
			{/* Search Box */}
			<Paper variant="outlined" sx={{ p: "2rem" }}>
				{/* Title */}
				<Box display="flex" gap="0.5rem" mb="1rem" alignItems="center">
					<SearchOutlined />
					<Typography variant="h4" fontWeight="700">
						Search Notes by Filters
					</Typography>
				</Box>

				<Stack spacing={2}>
					<TimePeriodPickerComponent
						setStartDate={setStartDate}
						setEndDate={setEndDate}
						setTimePeriod={setTimePeriod}
						allTimePast={allTimePast}
						today={today}
						timePeriod={timePeriod}
						startDate={startDate}
						endDate={endDate}
					/>

					{/* Search Bar */}
					<Autocomplete
						disabled={startDate === null || endDate === null}
						multiple
						fullWidth
						getOptionLabel={(option) => option.name}
						filterSelectedOptions
						// freeSolo
						/* Throttling Autocomplete */
						filterOptions={(x) => x} // disable filtering on client
						loading={isTyping}
						onInputChange={throttledHandleAutocompleteChange}
						options={options}
						onChange={handleValueChange}
						// isOptionEqualToValue={(option, value) => option._id === value._id}
						/* Rendering of Input Field, Option Items, and Chips/Tags */
						renderInput={(params) => (
							<TextField
								{...params}
								placeholder="Search Filters"
								InputProps={{
									...params.InputProps,
									endAdornment: (
										<Fragment>
											{isTyping ? (
												<CircularProgress color="inherit" size={20} />
											) : null}
											{params.InputProps.endAdornment}
										</Fragment>
									),
								}}
							/>
						)}
						renderOption={(props, option) => (
							<ListItem {...props} key={option._id}>
								{option.type === "owner" && (
									<ListItemAvatar>
										<Avatar />
									</ListItemAvatar>
								)}
								<ListItemText primary={option.name} secondary={option.type} />
							</ListItem>
						)}
						renderTags={(tagValue, getTagProps) =>
							tagValue?.map((option, index) => (
								<Chip
									variant="outlined"
									label={option.name || option}
									avatar={option.type === "owner" ? <Avatar /> : null}
									{...getTagProps({ index })}
								/>
							))
						}
					/>
				</Stack>
			</Paper>
			<Grid container spacing={2}>
				<Grid item xs={9}>
					<Box width="100%" height="100%" sx={{ flex: "1", mr: "1rem" }}>
						{values.length > 0 && (
							<Paper variant="outlined" sx={{ p: "2rem", mt: "2rem" }}>
								{graphData === null || graphData === undefined ? (
									<Box
										display="flex"
										justifyContent="center"
										alignItems="center"
										p="2rem"
									>
										{isError ? (
											<Typography variant="h4" color="error">
												Your query returned no results. Please try some
												different filters or change your workspace.
											</Typography>
										) : (
											<CircularProgress />
										)}
									</Box>
								) : (
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											height: "50vh",
										}}
									>
										<Box display="flex" alignItems="center" sx={{ mb: 1 }}>
											<Typography
												variant="h4"
												fontWeight="700"
												sx={{ flexGrow: 1 }}
												gutterBottom
											>
												Your Notes Visualized
											</Typography>
										</Box>
										<FlexBetweenBox
											id="notes-visualization"
											gap="0.5rem"
											mb="1rem"
											style={{ height: "50vh", width: "100%" }}
										>
											{graphData ? (
												<div style={containerStyles} ref={containerRef}>
													<Tree
														data={graphData}
														zoom="0.7"
														// nodeSvgShape={{
														// 	shape: 'none',
														// 	shapeProps: {}
														// }}
														rootNodeClassName="node__root"
														branchNodeClassName="node__branch"
														leafNodeClassName="node__leaf"
														orientation="vertical"
														dimensions={dimensions}
														translate={translate}
														renderCustomNodeElement={(rd3tProps) =>
															renderForeignObjectNode({
																...rd3tProps,
																foreignObjectProps,
															})
														}
													/>
												</div>
											) : (
												<Typography variant="h4" color="error">
													An error occurred while rendering your visualization.
													Please re-try this query set, or change your filters,
													workspace, or time period.
												</Typography>
											)}
										</FlexBetweenBox>
									</div>
								)}
							</Paper>
						)}
					</Box>
				</Grid>
				<Grid item xs={3}>
					<Box width="100%" height="100%" sx={{ flex: "1", ml: "1rem" }}>
						{values.length > 0 && (
							//root color: "#1f3e9e"
							//leaf color: "#f1f0fa"
							//intermediate color: "#b7c4ff"
							<Paper variant="outlined" sx={{ p: "2rem", mt: "2rem" }}>
								<Box display="flex" alignItems="center" sx={{ mb: 1 }}>
									<Box
										width="18px"
										height="18px"
										backgroundColor="#1f3e9e"
										sx={{ paddingRight: "10px" }}
									></Box>
									<Typography variant="h4" sx={{ paddingLeft: "10px" }}>
										Root Folder
									</Typography>
								</Box>
								<Box display="flex" alignItems="center" sx={{ mb: 1 }}>
									<Box
										width="18px"
										height="18px"
										backgroundColor="#b7c4ff"
										sx={{ paddingRight: "10px" }}
									></Box>
									<Typography variant="h4" sx={{ paddingLeft: "10px" }}>
										Intermediate Folder
									</Typography>
								</Box>
								<Box display="flex" alignItems="center" sx={{ mb: 1 }}>
									<Box
										width="18px"
										height="18px"
										backgroundColor="#f1f0fa"
										sx={{ paddingRight: "10px" }}
									></Box>
									<Typography variant="h4" sx={{ paddingLeft: "10px" }}>
										Doc File
									</Typography>
								</Box>
								<Divider variant="middle" />
								<Typography variant="h4" sx={{ mt: "1rem" }}>
									Select Doc File boxes to view document data
								</Typography>
								{/* <Typography variant="h4" sx={{ mt: "1rem" }}>
									Select Folder boxes to see aggregated summary
								</Typography> */}
							</Paper>
						)}
					</Box>
				</Grid>
			</Grid>

			<FileDialogComponent
				selectedNode={selectedNode}
				summaryData={summaryData}
				setSummaryData={setSummaryData}
				token={token}
				openDialog={openDialog}
				setOpenDialog={setOpenDialog}
			/>
		</Box>
	);
};

export default SearchPage;
